import { GrowthBook } from '@growthbook/growthbook';
import {
	thirdPartyTrackingPlugin,
	autoAttributesPlugin,
} from '@growthbook/growthbook/plugins';

const growthbook = new GrowthBook({
	apiHost: 'https://cdn.growthbook.io',
	clientKey: 'sdk-YsqaItSfrBuDvois',
	plugins: [
		autoAttributesPlugin({ uuidAutoPersist: false }),
		thirdPartyTrackingPlugin({ trackers: ['ga4', 'gtm'] }),
	],
});

// Wait for features to be available
(async () => {
	await growthbook.init({ streaming: true });
})();
